<template>
  <div style="background-color: white; overflow-y: hidden; width: 100%;height: 100%" >
    <Navbar/>
    <v-container id="policy" style="background: white;  padding: 16px !important;font-family: 'CS ChatThaiUI' !important; text-align: center; height: calc(100vh - 64px);" mt-5>
      <br>
      <div class="hidden-sm-and-down" style="height: calc(100% - 10vh);">
        <v-layout align-center justify-center column>
          <v-flex xs12 md12 sm12 xl12 lg12>
            <img style="margin-top: 0vw; width: 30vw;" src="/static/img/onechat/banner-homepage.jpg">
          </v-flex>
          <v-flex xs12 md12 sm12 xl12 lg12>
            <v-layout align-center row justify-center>
              <a href="https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat" target="_blank" class="mr-4">
                <img style="margin-top: 0vw; width: 15vw;" src="/static/img/download/googleplay.png">
              </a>
              <a href="https://itunes.apple.com/th/app/onechat/id1394435274?mt=8" target="_blank">
                <img style="margin-top: 0vw; width: 15vw;" src="/static/img/download/appstore.png">
              </a>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div class="hidden-md-and-up scrolling-wrapper" style="height: calc(100% - 10vh);">
        <v-layout align-center justify-center column>
          <v-flex xs12 md12 sm12>
            <img style="margin-top: 10vh; width: 70vw;" src="/static/img/onechat/banner-homepage.jpg">
          </v-flex>
          <v-flex xs12 md12 sm12>
            <v-layout align-center row justify-center>
              <a href="https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat" target="_blank">
                <img style="margin-top: 0vw; width: 35vw;" src="/static/img/download/googleplay.png">
              </a>
              <a href="https://itunes.apple.com/th/app/onechat/id1394435274?mt=8" target="_blank">
                <img style="margin-top: 0vw; width: 35vw;" src="/static/img/download/appstore.png">
              </a>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- <div class="footermo hidden-md-and-up"> -->
          <v-layout align-center column justify-center class="footermo">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>

              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toNewTab()">API</a> |</b></p>

              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>

              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
          </v-flex>
            <v-flex xs12 md12>
            <p style="padding-left: 20px; padding-right: 20px;color: black !important;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>

        </v-layout>
      </div>
        <div class="footer hidden-sm-and-down">
          <v-layout align-center row justify-center>
            <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>

            <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab()">API</a></b></p>

            <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>

            <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>

            <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
        </div>
      </v-container>
  </div>
</template>

<script>
import Navbar from '@/components/homepage/Navbar'
import Footer from '@/components/homepage/Footer'
// import NewFooter from '@/components/home/NewFooter'
export default {
  data: () => ({
    webdev: process.env.WEBchatdev
  }),
  components: {
    Navbar,
    Footer
  },
  methods: {
    toPage (page) {
      this.$router.push(page)
    },
    toNewTab () {
      window.open(this.webdev, '_blank').focus()
    }
  }
}
</script>

<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #2562af !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
.footermo {
   /*position: fixed;*/
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Download.vue